"use client";

import { Dialog, Box, Typography, Button, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

interface ThankYouCardProps {
  open: boolean;
  onClose: () => void;
}

export default function ThankYouCard({ open, onClose }: ThankYouCardProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "visible",
          background: "transparent",
          boxShadow: "none",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(253, 232, 224, 0.85)",
          },
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: { xs: 300, sm: 360 },
          mx: "auto",
        }}
      >
        {/* Brown shadow card behind */}
        <Box
          sx={{
            position: "absolute",
            top: 10,
            left: -8,
            right: -8,
            bottom: -10,
            backgroundColor: "#6D4C41",
            borderRadius: 4,
            transform: "rotate(-3deg)",
            zIndex: 0,
          }}
        />

        {/* Main white card */}
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            backgroundColor: colors.primary[900],
            borderRadius: 4,
            border: "1px solid rgba(109,76,65,0.12)",
            p: { xs: 4, sm: 5 },
            textAlign: "center",
          }}
        >
          <CheckCircleOutlineIcon
            sx={{
              fontSize: 56,
              color: "#2E7D32",
              mb: 2,
            }}
          />

          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#6D4C41",
              mb: 1.5,
              fontSize: { xs: "1.2rem", md: "1.4rem" },
            }}
          >
            Thank You for Registering
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#5D4037",
              mb: 4,
              lineHeight: 1.7,
              fontSize: "0.88rem",
            }}
          >
            Your Referral Partner registration has been received. {"We'll"}{" "}
            contact you within 24-48 hours to complete your activation.
          </Typography>

          <Button
            variant="contained"
            fullWidth
            onClick={onClose}
            sx={{
              backgroundColor: "#6D4C41",
              borderRadius: "24px",
              py: 1.5,
              mb: 1.5,
              fontSize: "0.95rem",
              "&:hover": { backgroundColor: "#4E342E" },
            }}
          >
            Home
          </Button>

          <Button
            variant="outlined"
            fullWidth
            href="https://wa.me/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              borderColor: "#6D4C41",
              borderRadius: "24px",
              color: "#6D4C41",
              py: 1.5,
              fontSize: "0.95rem",
              "&:hover": {
                borderColor: "#4E342E",
                backgroundColor: "rgba(109,76,65,0.05)",
              },
            }}
          >
            Chat with Us on Whatsapp
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
